import styled from "styled-components";

export const LogopedandpsyhologyContainer = styled.div`
    max-width: 1200px;
    width: 100%;
    margin: 60px auto 40px;
    padding: 0 var(--container-pad);
    display: flex;
    flex-direction: column;
    gap: 36px;

    @media (max-width: 600px) {
        margin-top: 40px;
        gap: 28px;
    }
`;

export const HeadText = styled.p`
    font-size: clamp(26px, 3vw, 32px);
    font-weight: 800;
    line-height: 1.2;
    color: var(--color-primary);
    letter-spacing: -0.5px;
    margin: 0 0 14px;
`;

export const NameText = styled.p`
    font-size: 18px;
    font-weight: 700;
    color: var(--color-primary);
    margin: 14px 0 0;
    text-align: center;
`;

export const MainText = styled.p`
    font-size: 15px;
    line-height: 1.65;
    color: var(--color-text);
    margin: 6px 0;
`;

export const MainHeadText = styled.p`
    font-size: 18px;
    font-weight: 700;
    color: var(--color-text);
    margin: 22px 0 6px;
`;

export const MainImage = styled.img`
    aspect-ratio: 7 / 8;
    max-width: 320px;
    width: 100%;
    object-fit: cover;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-md);
    border: none;

    @media (max-width: 600px) {
        max-width: 280px;
    }
`;

export const TeacherContainer = styled.div`
    display: grid;
    grid-template-columns: 340px 1fr;
    gap: 40px;
    align-items: start;
    background: white;
    border: 1px solid var(--color-border);
    border-radius: var(--radius-xl);
    padding: 32px;
    box-shadow: var(--shadow-sm);

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
        gap: 24px;
        padding: 24px;
    }

    @media (max-width: 600px) {
        padding: 20px;
    }
`;

export const TeacherTextContainer = styled.div`
    width: 100%;
`;

export const TeacherImageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;
